"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
const checkArgumentValidity_1 = require("../common/checkArgumentValidity");
exports.requestSchema = zod_1.z
    .object({
    propertyIds: zod_1.z.array(zod_1.z.number()).optional(),
    geoms: zod_1.z.array(zod_1.z.string()).optional(),
    lngLat: zod_1.z.array(zod_1.z.string()).optional(),
})
    .refine(checkArgumentValidity_1.checkIfOneArgumentIsUsed, { message: 'Only one selector may be used to query soil property data.' });
//# sourceMappingURL=soilFavoriteDepths.js.map